var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BulletLineWidget',{attrs:{"title":_vm.$t('product.pam.asset.conditions.widget.main-motor-current.title'),"current-value":_vm.mainCurrent,"unit":_vm.$t('product.pam.asset.conditions.widget.main-motor-current.unit'),"ranges":_vm.ranges}})}
var staticRenderFns = []

export { render, staticRenderFns }